export enum QuoteType {
    Unknown = 0,
    Indicative,
    Real
}